import React,{useState,useEffect} from 'react';
import { ResetModalStyle } from './ResetModal.styled';
import {ResetPasswordValidationSchema} from "../../validations/ResetPasswordValidation"
import CryptoJS from 'crypto-js';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ResetModal = ({ visible, setVisible,onAccept }) => {
  const [password, setPassword] = useState("")
  const [passwordErr, setPasswordErr] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [confirmPasswordErr, setConfirmPasswordErr] = useState("")
  const [error, setError] = useState(false)
  const [errorText, setErrorText] = useState("")

  useEffect(() => {
    setPassword("")
    setPasswordErr("")
    setConfirmPassword("")
    setConfirmPasswordErr("")
    setError("")
    setErrorText("")
  }, [visible])
  

  const handleResetPassword=()=>{
    let hashedpassword=CryptoJS.SHA256("43C5A34789D27162716FABCA379DBB65"+password)
    hashedpassword=hashedpassword.toString(CryptoJS.enc.Base64)
    onAccept(hashedpassword)
  }

  const Errors=(err)=>{
    err.forEach((element) => {
      switch(element.split(':')[0]){
        case "1":
          setPasswordErr(element.split(':')[1])
          break;
        case "2":
          setConfirmPasswordErr(element.split(':')[1])
          break;
        case "3":
          setPasswordErr(element.split(':')[1])
          break;
        default:
          setError(true)
          setErrorText("An Error has occured")
          break;

      }
    })
  } 

  const handleSubmit=async(event)=>{
    event.preventDefault();
    const formData={
      password,
      confirmPassword
    }

    await ResetPasswordValidationSchema.validate(formData,{
      abortEarly:false
    }).then((value)=>{
      handleResetPassword()
    }).catch((err)=>{
      Errors(err.errors)
    })
  }

  return (
    <Modal show={visible} onHide={setVisible}>
      <ResetModalStyle>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"red"}}>
            Reset Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className='form-container'>
            <label className='form-text' htmlFor='password' >
              Password
            </label>
            <input 
              type="password"
              id="password" 
              maxLength={30} 
              placeholder='Enter Password' 
              className={passwordErr!==""  ?"form-control mt-1 error-input" :'form-control mt-1 input-field'} 
              value={password} 
              onChange={e => {
                setPasswordErr("")
                setPassword(e.target.value)
              }} 
            />
            {passwordErr!==""?<p className='text-error'>{passwordErr}</p>:<p className='text-errorfade'>abc</p>}
                    
            <label className='form-text' htmlFor='confirm-password'>Confirm Password</label>
            <input 
              type="password"
              id="Confirm-password" 
              maxLength={30} 
              placeholder='Enter Confirm Password' 
              className={confirmPasswordErr!==""  ?"form-control mt-1 error-input" :'form-control mt-1 input-field'} 
              value={confirmPassword} 
              onChange={e => {
                setConfirmPasswordErr("")
                setConfirmPassword(e.target.value)
              }} 
            />
            {confirmPasswordErr!==""?<p className='text-error'>{confirmPasswordErr}</p>:<p className='text-errorfade'>abc</p>}
                    
          </form>
          {error ? <p className='text-error'>{errorText}</p>:<p className='text-errorfade'>abc</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={{backgroundColor:"red",borderColor:"red"}} onClick={setVisible}>
            Close
          </Button>
          <Button variant="primary" style={{backgroundColor:"Green",borderColor:"Green"}} onClick={handleSubmit}>
            OK
          </Button>
          
             
        </Modal.Footer>

      </ResetModalStyle>
    </Modal>
   
  );
};
export default ResetModal;
